import * as types from '../actions/types';

const initialState = {
  list: [{id: 1, name:'ктп1'}, {id: 2, name:'ктп2'}, {id: 3, name:'ктп3'}, ],
};

export default function ktp(state = initialState, action) {
  switch (action.type) {
    case types.KTP_LIST_FETCH_COMPLETED:
      return {
        ...state,
        list: action.list,
      };
    case types.KTP_FETCH_COMPLETED:
      return {
        ...state,
        ktp: action.ktp,
      };
    default:
      return state;
  }
}
